import React, { useState, CSSProperties } from "react";
import BounceLoader from "react-spinners/BounceLoader";

function Loader() {
  let [loading, setLoading] = useState(true);
	let [color, setColor] = useState("#000");
    const override: CSSProperties = {
			display: "block",
			margin: "0 auto",
			borderColor: "red",
		};
  return (
		<div style={{marginTop: '200px'}}>
			<BounceLoader
				color={color}
				loading={loading}
				cssOverride={override}
				size={100}
				aria-label="Loading Spinner"
				data-testid="loader"
			/>
		</div>
	);
}

export default Loader